// Field type constant for dynamic fields
export const FIELD_TYPE_DYNAMIC_FIELD = "dynamic_field" as const
